import type { CSSObject } from 'styled-components'

export const clampLines = (lines: number): CSSObject => ({
  display: '-webkit-box',
  WebkitLineClamp: lines,
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
})
